import React, { useState } from 'react';
import { cardTypes, brand } from '../../agentTheme';

/**
 * Renders marketing copy tool output as a visual preview card.
 * Shows headline, caption, CTA in proper hierarchy.
 */
export default function CopyPackageCard({ output }) {
  const [copied, setCopied] = useState(false);

  if (!output) return null;
  const { headline, caption, cta, platform, aspect_ratio, validation_warnings } = output;

  const handleCopy = async () => {
    const text = [headline, caption, cta].filter(Boolean).join('\n\n');
    try {
      await navigator.clipboard?.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { /* clipboard access denied — silently ignore */ }
  };

  return (
    <div className="smart-card" style={{ background: cardTypes.copy.bg, border: `1px solid ${cardTypes.copy.border}` }}>
      <div className="smart-card-header" style={{ color: cardTypes.copy.accent }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
        Marketing Copy
        {platform && (
          <span style={{
            fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 10,
            background: 'rgba(192,132,252,0.1)', border: `1px solid rgba(192,132,252,0.2)`,
            color: 'rgba(192,132,252,0.6)', marginLeft: 'auto',
          }}>
            {platform} {aspect_ratio && `· ${aspect_ratio}`}
          </span>
        )}
      </div>

      {headline && (
        <div style={{ marginTop: 10 }}>
          <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1.5, textTransform: 'uppercase', color: 'rgba(192,132,252,0.4)', marginBottom: 4 }}>
            Headline
          </div>
          <div style={{ fontSize: 16, fontWeight: 600, color: '#FFFFFF', lineHeight: 1.4 }}>
            {headline}
          </div>
        </div>
      )}

      {caption && (
        <div style={{ marginTop: 8 }}>
          <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1.5, textTransform: 'uppercase', color: 'rgba(192,132,252,0.4)', marginBottom: 4 }}>
            Caption
          </div>
          <div style={{
            fontSize: 13, color: 'rgba(255,255,255,0.65)', lineHeight: 1.5,
            overflow: 'hidden', textOverflow: 'ellipsis',
            display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical',
          }}>
            {caption}
          </div>
        </div>
      )}

      {cta && (
        <div style={{ marginTop: 8 }}>
          <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1.5, textTransform: 'uppercase', color: 'rgba(192,132,252,0.4)', marginBottom: 4 }}>
            CTA
          </div>
          <span style={{
            display: 'inline-block', padding: '6px 16px', borderRadius: 8,
            background: 'rgba(255,126,103,0.15)', border: '1px solid rgba(255,126,103,0.3)',
            color: brand.coral, fontSize: 12, fontWeight: 600,
          }}>
            {cta}
          </span>
        </div>
      )}

      {validation_warnings?.length > 0 && (
        <div style={{ marginTop: 8, fontSize: 11, color: 'rgba(251,191,36,0.6)', lineHeight: 1.5 }}>
          {validation_warnings.map((w, i) => (
            <div key={i} style={{ display: 'flex', gap: 4, marginTop: 2 }}>
              <span style={{ color: 'rgba(251,191,36,0.4)' }}>!</span> {w}
            </div>
          ))}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, marginTop: 12, justifyContent: 'flex-end' }}>
        <button
          onClick={handleCopy}
          style={{
            padding: '6px 14px', borderRadius: 8,
            border: '1px solid rgba(255,255,255,0.1)', background: 'transparent',
            color: copied ? '#4ade80' : 'rgba(255,255,255,0.5)',
            fontSize: 12, cursor: 'pointer', fontFamily: 'inherit',
            transition: 'all 150ms ease',
          }}
        >
          {copied ? 'Copied' : 'Copy All'}
        </button>
      </div>
    </div>
  );
}
